// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductEntry-module-header-ruc92{display:flex;gap:10px;margin-bottom:10px}.ProductEntry-module-imageContainer-XUE3K{background:#f5f5f5;width:83px;height:94px;display:flex;align-items:center;justify-content:center;border-radius:8px}.ProductEntry-module-image-XDbDJ{width:50px;height:60px;background-repeat:no-repeat;background-size:contain;background-position:center}.ProductEntry-module-descriptionContainer-mA-LG{flex:1 0}.ProductEntry-module-name-FdJAO{font-size:18px}.ProductEntry-module-descriptionAndPrice-Z0DNB{font-size:14px;line-height:23px}.ProductEntry-module-price-S0b3z{font-size:14px;font-weight:var(--weight-medium);letter-spacing:2.5px;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "ProductEntry-module-header-ruc92",
	"imageContainer": "ProductEntry-module-imageContainer-XUE3K",
	"image": "ProductEntry-module-image-XDbDJ",
	"descriptionContainer": "ProductEntry-module-descriptionContainer-mA-LG",
	"name": "ProductEntry-module-name-FdJAO",
	"descriptionAndPrice": "ProductEntry-module-descriptionAndPrice-Z0DNB",
	"price": "ProductEntry-module-price-S0b3z"
};
export default ___CSS_LOADER_EXPORT___;
